import { useCallback } from "react";
import { useLocalStorage } from "usehooks-ts";

export function useSidebar(key: string, initial = true) {
  const [isOpen, setOpened] = useLocalStorage(key, initial);
  const toggle = useCallback(() => setOpened((curr) => !curr), [setOpened]);
  const open = useCallback(() => setOpened(false), [setOpened]);
  const close = useCallback(() => setOpened(true), [setOpened]);
  return { isOpen, open, close, toggle };
}
